angular.module('app').directive('searchAutocomplete', function(appUtils) {
    return {
        'restrict': 'E',
        'scope': {
            'name': '@searchName',
            'label': '@searchLabel',
            'ctrl': '=searchCtrl',

        },
        'template': '' +
        '<md-autocomplete ' +
                'md-input-name="autocompleteField"' +
                'md-selected-item="selectedItem"' +
                'md-selected-item-change="update()"' +
                'md-search-text="searchText"' +
                'md-floating-label="{{ label }}"' +
                'md-search-text-change="search()"' +
                'md-items="searchItem in results"' +
                'md-item-text="searchItem.name"' +
                'md-clear-button="true" ' +
                'md-delay="300" ' +
                'md-require-match="true" ' +
                '<md-item-template>' +
                    '<span md-highlight-text="searchText">({{ searchItem.id }}) {{searchItem.name}}</span>' +
                '</md-item-template>' +
                '<md-not-found>No matches found</md-not-found>' +
            '</md-autocomplete>',
        'controller': function($scope, $http) {
            var fKey = $scope.name + '_id';
            $scope.ctrl.eqFields.push({
                'localName': fKey,
                'remoteName': fKey,
                'op': 'eq'
            });
            
            if($scope.ctrl.query[fKey]) {
                $scope.selectedItem = {'name': $scope.ctrl.query[fKey]};
                $scope.results = [
                    $scope.selectedItem
                ];
            }

            $scope.update = function() {
                if($scope.selectedItem) {
                    $scope.ctrl.query[fKey] = $scope.selectedItem.id; 
                } else {
                    $scope.ctrl.query[fKey] = null;
                }
                $scope.ctrl.load($scope);
            };

            $scope.search = function() {
                $scope.results = appUtils.search($scope.name, $scope.searchText);
            };
        }
    };
});

